import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Always initialize with 'dark' and lock it
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    const root = document.documentElement;
    
    // Remove both classes first
    root.classList?.remove('light', 'dark');
    
    // Always add dark class
    root.classList?.add('dark');
    
    // Save to localStorage
    localStorage.setItem('theme', 'dark');
  }, [theme]);

  // Disable theme toggling - always keep dark
  const toggleTheme = () => {
    // Do nothing - theme is locked to dark
  };

  const value = {
    theme: 'dark',
    toggleTheme,
    isDark: true
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;